import 'whatwg-fetch';
import PubSub from 'services/PubSub';
import StorageService from 'services/StorageService';
import Cookies from 'universal-cookie';
import OrdersService from 'services/Orders';
import { api } from 'config';
import SalesChannel from 'services/SalesChannel';
import TagManagerService from 'services/TagManager';
import PushNotification from 'services/PushNotification'
import { actionsType } from 'config/constants';
import Day from 'dayjs';
import VtexEvent from 'services/VtexEvent'

const getToken = () => {
    return fetch(`${api.user}/vtexid/pub/authentication/start`,{
        headers: {
            'x-api-key': api.apiKey
        }
    })
        .then(results => results.json())
        .then(
            results => {
                return results.authenticationToken || null;
            })
        .then(token => {
            StorageService.setItem('tokenEmail', token);
            return token;
        })
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}

const sendUserAccessKey = (email) => {
    return getToken().then(token => {
        if (!token) return false;

        return fetch(`${api.user}/vtexid/pub/authentication/accesskey/send`, {
            method: 'POST',
            headers: {
                'x-api-key': api.apiKey,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "authenticationToken": token,
                "login": email
            })
        })
            .then(results => results.json())
            .then(() => true)
            .catch(() => {
                PubSub.dispatch('error_503');
                return false
            });
    });
}

const updatePassword = (accessKey, email, password) => {
    const token = StorageService.getItem('tokenEmail');

    if (!token) return false;

    return fetch(`${api.user}/vtexid/pub/authentication/classic/setpassword`,{
        method: 'POST',
        headers: {
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            "authenticationToken": token,
            "login": email,
            "newPassword": password,
            "accessKey": accessKey
        })
    })
        .then(results => results.json())
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}

const userAuthentication = (email, password) => {
    return getToken().then(token => {
        return fetch(`${api.user}/vtexid/pub/authentication/classic/validate`, {
            method: 'POST',
            headers: {
                'x-api-key': api.apiKey,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "authenticationToken": token,
                "login": email,
                "password": password
            })
        })
            .then(results => results.json())
            .catch(() => {
                PubSub.dispatch('error_503');
                return false
            });
    });
}

const validatePrivateUrl = () => {
    const logged = isLogged();
    if(!logged && window) {
        window.location.href = '/login-page?callback='+window.location.pathname;
    }
}

const _getDeviceId = (email) => {
    return btoa(email + new Date().getTime());
}

const _setDeviceId = (email) => {
    if(!email) return null;

    let deviceId = StorageService.getItem('deviceId');
    if (!deviceId) {
        deviceId = _getDeviceId(email);
        StorageService.setItem('deviceId', deviceId)
    }
}

const setLogin = (data) => {
    StorageService.setItem('sessionData', data.token);
    StorageService.removeSecureItem('page-checkout');
    const cookies = new Cookies();
    const expDate = Day().day(30).toDate();
    cookies.set('shopping-list', data.token, { path: '/', domain: '.jumbo.cl', expires: expDate, secure: !PROJECT_ENV.authDevelopment });
    StorageService.setSecureItem('userData', data.user);
    generateSessionId();

    _setDeviceId(data.user.email);
    TagManagerService.userId();
    PushNotification.registerUser();

    VtexEvent.sessionUser(data.user);

    createProfileData(false, data.token).then( () => {
        PubSub.dispatch(actionsType.LOGGED_IN);
    });
}

const generateSessionId = (refresh = false) => {
    const data = StorageService.getSecureItem('userData');
    const sessionId = StorageService.getItem('sessionId');

    if(data && btoa && (!sessionId || refresh)){
        StorageService.setItem('sessionId', btoa(data.email + new Date().getTime()));
        StorageService.removeItem('anonymousSessionId');
    }
}

const logout = () => {
    const sessionData = StorageService.getItem('sessionData');
    const cookies = new Cookies();
    cookies.remove('shopping-list', { path: '/', domain: '.jumbo.cl', secure: !PROJECT_ENV.authDevelopment });
    if(sessionData){
        OrdersService.clearCachedOrder();
        StorageService.removeItem('sessionData');
        StorageService.removeItem('tokenEmail');
        StorageService.removeItem('removed_items');
        StorageService.removeSecureItem('userData');
        StorageService.removeSecureItem('address');
        StorageService.removeSecureItem('delivery-option');
        StorageService.removeItem('productsRemoved');
        StorageService.removeSecureItem('page-checkout');
        StorageService.removeItem('old_sales_channel_info');
        StorageService.removeItem('preselected_shipping_method');
        StorageService.removeItem('store_name');
        StorageService.setItem('store_name', 'Jumbo Chile');
        StorageService.removeItem('modal-date-delivery-open');
        StorageService.removeItem('deliveryExpressSelected');
        StorageService.removeItem('notExpress');
        StorageService.removeItem('windowSent');
        SalesChannel.removeAll();
        return true;
    }
    return false;
}

const isLogged = ()=> {
    const sessionData = StorageService.getItem('sessionData');
    const userData = StorageService.getSecureItem('userData');

    return (userData && userData.email && sessionData)
}

const getUserData = () => {
    return StorageService.getSecureItem('userData');
};

const jwtLogged = () => {
    const sessionData = StorageService.getItem('sessionData');

    if(!sessionData) return new Promise( (resolve) => resolve('not Logged'));

    return fetch(api.user + `/user/vtex-auth/token`, {
        headers: {
            'token': sessionData,
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json'
        },
    }).then(results => results.json()).then(results => {
        const {status} = results;

        return !(status && status === 401);
    });
}

const registerUser = (data, sessionData) => {
    return fetch(`${api.user}/user`, {
        method: 'POST',
        headers: {
            'token': sessionData,
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
    }).then(results => results.json())
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}

const createProfileData = (oFormId = false, tokenId = false) => {
    const token = tokenId ? tokenId : StorageService.getItem('sessionData');
    const orderFormId = oFormId ? oFormId : StorageService.getItem('orderFormId');

    return fetch(`${api.user}/user/profile`, {
        method: 'POST',
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            "orderFormId": orderFormId
        })
    })
        .then(results => results.json())
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}

const getUserToken = () => {
    return StorageService.getItem('sessionData');
}

const isPrime = () => {
    const dataUser = StorageService.getSecureItem('userData');
    return dataUser && !!dataUser['CencoPrime_2020'];
}

const LoginService = {
    getUserToken,
    createProfileData,
    registerUser,
    jwtLogged,
    isLogged,
    logout,
    setLogin,
    userAuthentication,
    updatePassword,
    sendUserAccessKey,
    validatePrivateUrl,
    getUserData,
    generateSessionId,
    isPrime
}

export default LoginService;
